export const TRANSITION = '0.1s';
